import * as angular from "angular";
import * as _ from "lodash";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { HouseOccupantDataProvider } from "../../data-provider/house-occupant.dp";
import { Group } from "../../models/group.model";
import { FilterService } from "../../services/filter.service";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { GroupDataProvider } from "../../data-provider/group.dp";
import { CheckManager } from "../../shared/check-manager";
import { Campaign } from "../../models/campaign.model";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { PermissionCheck } from "../../shared/permission";
import { Assignment } from "../../models/assignment.model";
import { GroupColorDataProvider } from "../../data-provider/group-color.dp";

let CreateGroupComponent = {
    selector: "vcCreateGroup",
    templateUrl: "/angular/components/group/group-create.component.html",
    bindings: {
        group: "=",
        assign: "=",
        autoSplitAssign: "=",
        street: "=?",
        properties: "=?",
        listViewDataProvider: "=?",
    },
    controller: class CreateGroupController {
        // * bindings for typescript compiler *
        public group: Group;
        public assign: any;
        public autoSplitAssign: any;
        public properties: any;
        // ************************************
        public activeCampaign: Campaign;
        public editgroup: Group;
        public assignMode: boolean;
        public showAssignment: boolean = false;
        public assignments: Assignment[] = [];
        public autoFillList = false;
        public nonEmptyFilters: object;
        public hideDynamicListRadioButtons: boolean;
        public loading = false;
        private selectedPropIndex: string;
        public colors: string[];
        public customColor: string = "#000000";
        private __env: any;
        private toast: ToastUtils;
        private dialog: DialogUtils;
        private modelsUtils: any;

        private dataProvider: GroupDataProvider;
        private filterService: FilterService;
        private houseOccupantDataProvider: HouseOccupantDataProvider;
        private filterDataProvider: any;
        private street: any;
        private listViewDataProvider: any;
        private checkManager: CheckManager;
        public readonly permissionProvider: PermissionCheck;

        private readonly $scope: any;
        constructor(
            __env: any,
            $scope: any,
            TeamDataProvider: TeamDataProvider,
            GroupDataProvider: GroupDataProvider,
            FilterDataProvider: FilterDataProvider,
            FilterService: FilterService,
            HouseOccupantDataProvider: HouseOccupantDataProvider,
            CampaignDataProvider: CampaignDataProvider,
            ToastUtils: ToastUtils,
            DialogUtils: DialogUtils,
            ModelsUtils: any,
            PermissionCheck: PermissionCheck,
            GroupColorDataProvider: GroupColorDataProvider
        ) {
            this.__env = __env;
            this.toast = ToastUtils;
            this.dialog = DialogUtils;
            this.modelsUtils = ModelsUtils;

            this.dataProvider = GroupDataProvider;
            this.filterService = FilterService;
            this.houseOccupantDataProvider = HouseOccupantDataProvider;
            this.filterDataProvider = FilterDataProvider;
            this.permissionProvider = PermissionCheck;
            this.$scope = $scope;

            this.colors = GroupColorDataProvider.groupColours;
            this.activeCampaign = CampaignDataProvider.getActiveCampaign();
        }

        $onInit() {
            this.editgroup = this.modelsUtils.group(this.group);
            if (this.properties && Object.keys(this.properties).length) {
                if (this.activeCampaign && this.activeCampaign.localInfo) {
                    this.selectedPropIndex =
                        this.activeCampaign.localInfo.selectedPropIndex;

                    this.editgroup.gname =
                        this.properties[this.selectedPropIndex];
                }
            } else {
                this.properties = null;
            }
            this.assignMode = this.assign;
            this.showAssignment = this.assign;
            this.assignments =
                this.editgroup.assignments &&
                this.editgroup.assignments.length > 0
                    ? this.editgroup.assignments.filter(
                          (assignment: Assignment) =>
                              assignment.status !== "Deleted"
                      )
                    : [];
            if (
                (this.group && this.group.gid && this.group.filters) ||
                (!this.group.gid && this.group.points)
            ) {
                this.autoFillList = true;
            }

            if (
                this.listViewDataProvider &&
                this.listViewDataProvider.checkManager
            ) {
                this.checkManager = this.listViewDataProvider.checkManager;
            }

            this.nonEmptyFilters = this.generateFilterObject();
            this.hideDynamicListRadioButtons =
                (this.checkManager && !this.checkManager.all_checked) ||
                angular.equals(this.nonEmptyFilters, {});
        }

        generateFilterObject(): object {
            let filter = this.filterDataProvider.nonEmptyAppliedFilters(true);
            if (this.group.points) {
                filter["turf_cut"] = true;
            }
            return filter;
        }

        dynamicListInfo(ev: object): void {
            const alertDialog = this.dialog
                .alert()
                .title("Dynamic Lists")
                .htmlContent(
                    "<p><strong>A static list</strong> consists of contacts that you have built once which you can edit manually to make any changes.</p>" +
                        "<p><strong>A dynamic list</strong> retains the exact filter criteria that were in place when the list was created. " +
                        "As contacts are added, updated, or removed in your database with attributes that match the filter criteria of the dynamic list, these contacts will automatically be added or removed from the list. Dynamic Lists are refreshed hourly.</p>" +
                        "<p><strong> The Auto - Split & Assign </strong> feature is not available with dynamic lists.</p > <br/>" +
                        "<p><strong> Note:</strong> All lists have a maximum size of 20,000</p>"
                )
                .multiple(true)
                .targetEvent(ev)
                .ok("OK");
            this.dialog.showPreConfiguredDialog(alertDialog);
        }

        setAutoFillList(newValue: boolean): void {
            this.autoFillList = newValue;
        }

        cancel(): void {
            this.dialog.cancel();
        }

        createFilterWithGid(filter: object): void {
            filter["filters"].street = this.street;
            this.filterService.create(filter).then((response: object) => {
                const json = response["data"];
                if (json.success) {
                    json.data.fid = json.id;
                }
            });
        }

        saveGroup(): void {
            this.loading = true;
            let numHouseOccs = this.group.points
                ? 0
                : this.houseOccupantDataProvider.checkManager
                      .checked_items_count;

            this.editgroup.assignments = this.assignments;

            if (numHouseOccs > 20000) {
                this.listTooBig();
                return;
            } else {
                if (this.editgroup.gid) {
                    this.editgroup.update().then((group: Group) => {
                        if (this.autoFillList && !this.group.filters) {
                            group.filters = {
                                fname: group.gname,
                                filters: this.nonEmptyFilters,
                                gid: group.gid,
                            };
                            this.createFilterWithGid(group.filters);
                        } else if (!this.autoFillList && this.group.filters) {
                            this.filterDataProvider.deleteGroupFilter(
                                this.group.gid
                            );
                            group.filters = null;
                            this.toast.success("List Updated");
                            this.dialog.hide(group);
                            this.loading = false;
                            return;
                        }
                        this.toast.success("List Updated");
                        this.dialog.hide(group);
                        this.loading = false;
                    });
                } else {
                    this.dataProvider
                        .createGroup(this.editgroup)
                        .then((group: Group) => {
                            if (this.autoFillList === true) {
                                this.createFilterWithGid({
                                    fname: group.gname,
                                    filters: this.nonEmptyFilters,
                                    gid: group.gid,
                                });
                            }
                            this.toast.success("List Created");
                            this.dialog.hide(group);
                            this.loading = false;
                        });
                }
            }
        }

        listTooBig(): void {
            const listToBigAlert = this.dialog
                .alert()
                .title(`List Too Big`)
                .htmlContent(
                    `<p class="no-margin">We cannot complete this action as it will result in exceeding the list size maximum of 20,000 ${this.__env.strings.voters}.</p>
                <p class="no-margin">List limits are in place to prevent excessive mobile data usage and provide an optimal experience using the mobile app.</p>`
                )
                .escapeToClose(false)
                .ok("Close");
            this.dialog.showPreConfiguredDialog(listToBigAlert);
        }

        viewProperties(ev: any): void {
            this.dialog
                .show({
                    component: "vc-select-property-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "small",
                    locals: {
                        label: "Select tag as list name",
                        properties: this.properties,
                        selectedIndex: this.selectedPropIndex,
                    },
                })
                .then((index: string) => {
                    this.selectedPropIndex = index;
                    this.editgroup.gname = this.properties[index];
                });
        }
        newAssignment(ev: any): void {
            this.dialog
                .show({
                    component: "vc-group-assignment",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        listName: this.group.gname,
                        assignment: this.modelsUtils.assignment({
                            assignmentname: "List Assignment",
                        }),
                    },
                })
                .then((assignment: Assignment) => {
                    if (assignment) this.assignments.push(assignment);
                });
        }
        editAssignment(assignment: Assignment, ev: any): void {
            this.dialog
                .show({
                    component: "vc-group-assignment",
                    targetEvent: ev,
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        listName: this.group.gname,
                        assignment: angular.copy(assignment),
                    },
                })
                .then((edited: Assignment) => {
                    if (edited) {
                        assignment.teams = edited.teams;
                        assignment.users = edited.users;
                        _.merge(assignment, edited);
                    }
                });
        }

        deleteAssignment(assignment: Assignment, ev: any): void {
            this.dialog
                .delete({
                    targetEvent: ev,
                    multiple: true,
                    locals: {
                        bodyText:
                            "Are you sure you want to delete this assignment?",
                        title: "Delete Assignment",
                    },
                })
                .then(() => {
                    if (!assignment.id) {
                        this.assignments = this.assignments.filter(function (
                            item
                        ) {
                            return item !== assignment;
                        });
                    } else {
                        assignment.status = "Deleted";
                    }
                });
        }

        selectColor(color: string): void {
            this.editgroup.color = color;
        }
    },
};

angular
    .module("group", ["checkManager"])
    .component(CreateGroupComponent.selector, CreateGroupComponent);
